import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import th from '../translations/th';
import en from '../translations/en';

const translations = { th, en };
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try { return localStorage.getItem('app_lang') || 'th'; }
        catch { return 'th'; }
    });

    useEffect(() => {
        try { localStorage.setItem('app_lang', lang); }
        catch { /* ignore */ }
        document.documentElement.lang = lang === 'th' ? 'th' : 'en';
    }, [lang]);

    const toggleLang = useCallback(() => {
        setLang(prev => prev === 'th' ? 'en' : 'th');
    }, []);

    const t = useCallback((key) => {
        const keys = key.split('.');
        let value = translations[lang];
        for (const k of keys) {
            value = value?.[k];
            if (value === undefined) break;
        }
        if (value === undefined) {
            // Fallback to Thai
            let fallback = translations.th;
            for (const k of keys) {
                fallback = fallback?.[k];
                if (fallback === undefined) break;
            }
            return fallback || key;
        }
        return value;
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
    return ctx;
}

export default LanguageContext;
